import * as actionTypes from '../actions'

const initialState = {
  integration: null,
  cities: [],
  quotation: null,
  quotationError: null
}

const aveonlineReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_AVEONLINE_INTEGRATION: {
      return {
        ...state,
        integration: action.payload
      }
    }
    case actionTypes.GET_CITIES_AVEONLINE: {
      return {
        ...state,
        cities: action.payload
      }
    }
    case actionTypes.GET_AVEONLINE_QUOTATION: {
      return {
        ...state,
        quotation: action.payload,
        quotationError: null
      }
    }
    case actionTypes.SET_AVEONLINE_QUOTATION_ERROR: {
      return {
        ...state,
        quotationError: action.payload
      }
    }
    case actionTypes.RESET_AVEONLINE_QUOTATION: {
      return {
        ...state,
        quotation: null,
        quotationError: null
      }
    }
    default: {
      return state
    }
  }
}

export default aveonlineReducer
